import { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Error from "../../ErrorPages/Error";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import Swal from "sweetalert2";

const QualitySampleSize = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const qcSelections = location.state?.data;
    const userId = secureLocalStorage.getItem("userID");

    console.log(qcSelections);

    const [batchData, setBatchData] = useState(null);

    const { useCreate: useCheckBatch } = useAPIQuery({
        key: "check-batch",
        endpoint: "/api/check-batch/",
    });

    const { mutate: checkBatch, isPending } = useCheckBatch({
        errorMessageFromServer: true,
        // successMessageFromServer: true,
        onSuccess: (data) => {
            Swal.fire({
                title: "Success!",
                text: data?.message,
                icon: "success",
            }).then((result) => {
                if (result.isConfirmed) {
                    if (batchData) {
                        navigate("/select-parameters", {
                            state: {
                                data: { ...qcSelections, batch: data },
                            },
                        });
                    }
                }
            });
        },
    });

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
    } = useForm({
        mode: "onBlur",
    });

    const onSubmit = (data) => {
        console.log(data);
        const batch = {};
        if (qcSelections) {
            if (
                qcSelections?.item?.category?.toLowerCase() ===
                "Raw Material"?.toLowerCase()
            ) {
                batch["batch_id"] = qcSelections?.daily_purchased_order?.value;
                batch["po_id"] = qcSelections?.daily_purchased_order?.po_id;
                // batch["daily_plan"] = "";
                batch["type_name"] = qcSelections?.item?.category;
            } else if (
                qcSelections?.item?.category?.toLowerCase() ===
                    "wip"?.toLowerCase() ||
                qcSelections?.item?.category?.toLowerCase() ===
                    "FG"?.toLowerCase()
            ) {
                // batch["po_id"] = "";
                batch["daily_plan_id"] =
                    qcSelections?.daily_purchased_order?.value;
                batch["type_name"] = qcSelections?.item?.category;
            }
            batch["total_quantity"] = Number(data.total_quantity);
            batch["sampling_quantity"] = Number(data.sample_quantity);
            batch["incharge_id"] = userId;
            batch["report_date"] = moment(new Date()).format(
                "YYYY-MM-DD HH:mm"
            );
            batch["triggered_type"] = "triggered";
            batch["item_id"] = qcSelections?.item?.id;
            batch["created_by"] = userId;
            batch["updated_by"] = userId;

            console.log(batch);

            setBatchData(batch);
            checkBatch({
                data: batch,
            });
        }
    };

    console.log(qcSelections);

    if (!qcSelections) return <Error />;

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Sample Size </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Total Quantity
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="number"
                                        step={"any"}
                                        className="form-control"
                                        placeholder="Enter total quantity"
                                        id="text-forms-total_quantity"
                                        {...register("total_quantity", {
                                            required:
                                                "Total quantity is required",
                                            validate: (val) => {
                                                if (val <= 0) {
                                                    return "Only positive numbers are allowed";
                                                }

                                                if (
                                                    qcSelections?.item
                                                        ?.category === "WIP" &&
                                                    !Number.isInteger(
                                                        Number(val)
                                                    )
                                                ) {
                                                    return "Only whole numbers are allowed for WIP items";
                                                }

                                                if (
                                                    Number(val) >
                                                    Number(
                                                        qcSelections?.total_quantiy
                                                    )
                                                ) {
                                                    return `Total quantity cannot be greater than available quantity (${qcSelections?.total_quantiy})`;
                                                }
                                            },
                                        })}
                                        defaultValue={
                                            qcSelections?.total_quantiy
                                        }
                                    />
                                    {errors.total_quantity && (
                                        <span className="fs-8 text-danger">
                                            {errors.total_quantity?.message}
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Sample Quantity
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="number"
                                        step={"any"}
                                        className="form-control"
                                        placeholder="Enter sample quantity"
                                        id="text-forms-sample-quantity"
                                        {...register("sample_quantity", {
                                            required:
                                                "Sample quantity is required",
                                            validate: {
                                                positive: (value) =>
                                                    !value ||
                                                    value > 0 ||
                                                    "Only positive numbers are allowed",
                                                isIneger: (val) => {
                                                    if (
                                                        qcSelections?.item
                                                            ?.category ===
                                                            "WIP" &&
                                                        !Number.isInteger(
                                                            Number(val)
                                                        )
                                                    ) {
                                                        return "Only whole numbers are allowed for WIP items";
                                                    }
                                                },
                                                lessThanTotal: (value) =>
                                                    !value ||
                                                    Number(value) <=
                                                        Number(
                                                            watch(
                                                                "total_quantity"
                                                            )
                                                        ) ||
                                                    "Sample quantity cannot be greater than total quantity",
                                            },
                                        })}
                                        defaultValue={qcSelections?.sample_size}
                                    />
                                    {errors.sample_quantity && (
                                        <span className="fs-8 text-danger">
                                            {errors.sample_quantity.message}
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-typemaster-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-create-typemaster"
                                            >
                                                Submit
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QualitySampleSize;
